'use client';

import clsx from 'clsx';
import type { ReactNode } from 'react';
import { Link, usePathname } from '~/i18n/navigation';

export function AccountMenuLink({ href, children }: { href: string; children: ReactNode }) {
  const pathname = usePathname();

  return (
    <Link
      href={href}
      className={clsx(
        'flex items-center h-full px-2 md:px-4 pt-4 pb-3 typography-emphasis-1 whitespace-nowrap border-b-4 border-white',
        pathname === href && 'border-b-primary-500'
      )}
    >
      {children}
    </Link>
  );
}
